/**
 * Mapping des codes d'erreur backend vers des messages utilisateur en français.
 */

const ERROR_MESSAGES: Record<string, string> = {
  email_already_exists: "Cet email est déjà utilisé.",
  last_active_admin: "Impossible : c'est le dernier administrateur actif.",
  admin_required: "Permission administrateur requise.",
  account_disabled: "Compte désactivé.",
  invalid_credentials: "Identifiants invalides.",
  external_provider: "Compte externe (SSO/OIDC), changement de mot de passe non disponible.",
  rate_limited: "Trop de tentatives, réessayez dans une minute.",
};

export function mapError(error: string | undefined): string {
  if (!error) return "Erreur inconnue.";
  return ERROR_MESSAGES[error] || error;
}
